import Axios from 'axios';
import { SecurityActionTypes } from '../../redux/Actions/Security/ActionTypes';

const defaultOptions = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
};

Axios.defaults.baseURL = defaultOptions.baseURL;
Axios.defaults.headers.common['Content-Type'] = defaultOptions.headers;

const Api = Axios;
export default Api;

export function setupInterceptors(store: any): void {
  Api.interceptors.response.use(undefined, error => {
    if (error.response && error.response.status === 401) {
      console.log('401 error', error);
      store.dispatch({
        type: SecurityActionTypes.UNAUTH_USER,
        payload: { message: 'Your Session expired!' }
      });
    }
    return Promise.reject(error);
  });
}
